// ============================================================================
// TOP > バナースライダー
// ============================================================================
document.addEventListener("DOMContentLoaded", function () {
  function topBannerSlider(){
    setTimeout(function () {
        const sliderSwiper = new Swiper(".p-top-slider__swiper", {
            loop: true,
            centeredSlides: true,
            spaceBetween: 24,
            slidesPerView: 1.34,
            speed: 1000,
            autoplay: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 3.37,
                },
            }
        });
    }, 300);
  }
  topBannerSlider();
  document.addEventListener("shopify:section:load", function () {
      topBannerSlider();
  });
});

// ============================================================================
// TOP > カテゴリタブ切り替え
// ============================================================================
document.addEventListener('DOMContentLoaded', function () {
    const tabSections = document.querySelectorAll('.tab-section');

    tabSections.forEach(section => {
        const buttons = section.querySelectorAll('.tab-button');
        const contents = section.querySelectorAll('.tab-content');

        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const target = button.dataset.tab;

                // ボタンの切り替え
                buttons.forEach(btn => btn.classList.remove('is-active'));
                button.classList.add('is-active');

                // コンテンツの切り替え
                contents.forEach(content => {
                    if (content.dataset.content === target) {
                        content.classList.add('is-active');
                        console.log('変更１');
                    } else {
                        content.classList.remove('is-active');
                        console.log('変更２');
                    }
                });
            });
        });
    });
});


// ============================================================================
// 商品 > バナースライダー
// ============================================================================
document.addEventListener("DOMContentLoaded", function () {
function productBannerSlider(){
    const productSwiper = new Swiper(".p-product-slider__swiper", {
        loop: true,
        centeredSlides: true,
        spaceBetween: 14,
        slidesPerView: 1.2,
        speed: 1000,
        autoplay: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            1024: {
                slidesPerView: 1.85,
                spaceBetween: 72,
            },
            768: {
                slidesPerView: 1.5,
                spaceBetween: 40,
            },
        }
    });
}
productBannerSlider();
    document.addEventListener("shopify:section:load", function () {
      productBannerSlider();
  });
});

// ============================================================================
// 商品 > 関連商品スライダー
// ============================================================================
document.addEventListener("DOMContentLoaded", function () {
function productRelatedSlider(){
    const relatedSwiper = new Swiper(".p-related-slider__swiper", {
        loop: true,
        centeredSlides: false,
        slidesPerView: 3.4,
        spaceBetween: 8,
        speed: 600,
        autoplay: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            1024: {
                slidesPerView: 3.4,
                spaceBetween: 24,
                autoplay: false,
            },
            768: {
                slidesPerView: 3.2,
                spaceBetween: 16,
            },
        }
    });
}
  productRelatedSlider();
  document.addEventListener("shopify:section:load", function () {
      productRelatedSlider();
  });
});



document.addEventListener('DOMContentLoaded', function() {
    // quantity-selectorとbuy-buttonフォームを同期
    const quantityInputs = document.querySelectorAll('.quantity__input');
    
    quantityInputs.forEach(input => {
        input.addEventListener('change', function() {
            const formId = this.getAttribute('form');
            const form = document.getElementById(formId);
            if (form) {
                const formQuantityInput = form.querySelector('input[name="quantity"]');
                if (formQuantityInput) {
                    formQuantityInput.value = this.value;
                }
            }
        });
    });
});


// ============================================================================
// 割引時の表示
// ============================================================================
document.addEventListener('DOMContentLoaded', function() {
    // Cookieから値を取得する関数
    function getCookie(name) {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            const [key, value] = cookie.trim().split('=');
            if (key === name) {
                return decodeURIComponent(value);
            }
        }
        return null;
    }

    // 割引価格を計算する関数
    function calculateDiscountedPrice(originalPrice, discountType, discountValue) {
        const price = parseFloat(originalPrice);
        const discount = parseFloat(discountValue);
        
        if (discountType === '割合') {
            return price * (1 - discount / 100);
        } else if (discountType === '定額') {
            return Math.max(0, price - discount);
        }
        return price;
    }

    // 商品ページのバッジエリアにセールバッジを追加する関数
    function addProductPageBadge(matchingDiscount, currentProductId) {
        // 商品情報コンテナを探す
        const productInfoContainers = document.querySelectorAll('.product__info-container');
        
        productInfoContainers.forEach((container) => {
            // 既存のバッジエリアを探す
            let badgesBlock = container.querySelector('.product__badges');
            
            // バッジエリアが存在しない場合は作成
            if (!badgesBlock) {
                const priceBlock = container.querySelector('[id^="price-"]') ||
                                container.querySelector('.product__block--price');
                
                if (priceBlock) {
                    badgesBlock = document.createElement('div');
                    badgesBlock.className = 'product__block product__block--badges product__badges flex flex-wrap items-center';
                    badgesBlock.setAttribute('id', `Badges-discount-${currentProductId}`);
                    priceBlock.parentNode.insertBefore(badgesBlock, priceBlock);
                }
            }
            
            if (badgesBlock) {
                // 価格情報を取得
                const priceElement = container.querySelector('.f-price');
                let badgeText = 'Sale';
                
                // 商品IDを確認して、対象商品かどうかをチェック
                const productId = priceElement ? priceElement.getAttribute('data-product-id') : currentProductId;
                const targetProductIds = matchingDiscount.products || [];
                const isTargetProduct = productId && targetProductIds.map(id => String(id)).includes(String(productId));
                
                // 対象商品でない場合は、バッジを追加しない
                if (!isTargetProduct) {
                    return;
                }
                
                if (priceElement) {
                    const dataCompareAtPrice = priceElement.getAttribute('data-compare-at-price');
                    const dataOriginalPrice = priceElement.getAttribute('data-original-price');
                    
                    // バッジ設定を取得
                    const badgeSettings = window.saleBadgeSettings || { type: 'text', showBadge: true };
                    
                    if (badgeSettings.type === 'percentage' || badgeSettings.type === 'fixed_amount') {
                        // 元の定価を取得（compare_at_priceがあればそれを使用、なければoriginal_priceを使用）
                        let originalPrice, currentPrice;
                        
                        if (dataCompareAtPrice && dataCompareAtPrice !== '') {
                            // 元々セール商品の場合：元の定価から計算
                            originalPrice = parseFloat(dataCompareAtPrice) / 100;
                            currentPrice = parseFloat(dataOriginalPrice) / 100;
                        } else {
                            // 通常価格の商品の場合
                            originalPrice = parseFloat(dataOriginalPrice) / 100;
                            currentPrice = originalPrice;
                        }
                        
                        // クーポン適用後の最終価格を計算
                        const finalPrice = calculateDiscountedPrice(currentPrice, matchingDiscount.type, matchingDiscount.value);
                        
                        if (badgeSettings.type === 'percentage') {
                            // 元の定価からの総割引率を計算
                            const totalDiscountPercentage = Math.round((originalPrice - finalPrice) / originalPrice * 100);
                            badgeText = `${totalDiscountPercentage}% OFF`;
                        } else if (badgeSettings.type === 'fixed_amount') {
                            // 割引額を計算
                            const discountAmount = Math.floor(originalPrice - finalPrice);
                            badgeText = `-${discountAmount.toLocaleString('ja-JP')}円`;
                        }
                    }
                }
                
                // 既存のセールバッジを確認して更新または新規作成
                const existingSaleBadge = badgesBlock.querySelector('.f-badge--sale');
                
                if (existingSaleBadge) {
                    // 既存のバッジを更新
                    existingSaleBadge.textContent = badgeText;
                    existingSaleBadge.classList.add('f-badge--discount');
                } else {
                    // 新規バッジを作成
                    const discountBadge = document.createElement('span');
                    discountBadge.className = 'f-badge f-badge--sale f-badge--discount';
                    discountBadge.textContent = badgeText;
                    badgesBlock.appendChild(discountBadge);
                }
            }
        });
    }

    // 単一の価格要素を更新する関数
    function updateSinglePriceElement(priceElement, matchingDiscount) {
        // 既に処理済みかチェック
        if (priceElement.hasAttribute('data-discount-applied')) {
            return;
        }
        
        // 既にセール価格で表示されているかチェック
        const existingSaleDiv = priceElement.querySelector('.f-price__sale');
        const existingRegularDiv = priceElement.querySelector('.f-price__regular');
        
        let originalPrice, originalPriceText;
        
        if (existingSaleDiv && priceElement.classList.contains('f-price--on-sale')) {
            // 既にセール価格で表示されている場合
            const dataOriginalPrice = priceElement.getAttribute('data-original-price');
            const dataCompareAtPrice = priceElement.getAttribute('data-compare-at-price');
            
            if (dataOriginalPrice) {
                // data属性から正しいセール価格を使用（centからyenに変換）
                originalPrice = parseFloat(dataOriginalPrice) / 100;
                originalPriceText = originalPrice.toLocaleString('ja-JP') + '円';
            } else {
                // フォールバック：現在のセール価格を取得
                const currentSalePriceElement = existingSaleDiv.querySelector('.f-price-item--sale');
                if (!currentSalePriceElement) {
                    return;
                }
                
                const currentSalePriceText = currentSalePriceElement.textContent.trim();
                originalPrice = parseFloat(currentSalePriceText.replace(/[^\d.]/g, ''));
                originalPriceText = currentSalePriceText;
            }
            
            // 割引前価格（compare_at_price）を通常価格として表示
            if (dataCompareAtPrice && existingRegularDiv) {
                const compareAtPriceFormatted = (parseFloat(dataCompareAtPrice) / 100).toLocaleString('ja-JP') + '円';
                
                const regularPriceItem = existingRegularDiv.querySelector('.f-price-item--regular');
                if (regularPriceItem) {
                    regularPriceItem.textContent = compareAtPriceFormatted;
                    existingRegularDiv.style.display = 'block';
                }
            }
        } else {
            // 通常価格で表示されている場合
            const dataOriginalPrice = priceElement.getAttribute('data-original-price');
            
            if (dataOriginalPrice) {
                // data属性から正しい価格を使用（centからyenに変換）
                originalPrice = parseFloat(dataOriginalPrice) / 100;
                originalPriceText = originalPrice.toLocaleString('ja-JP') + '円';
            } else {
                // フォールバック：表示されている価格を取得
                const regularPriceElement = existingRegularDiv?.querySelector('.f-price-item--regular');
                if (!regularPriceElement) {
                    return;
                }
                
                originalPriceText = regularPriceElement.textContent.trim();
                originalPrice = parseFloat(originalPriceText.replace(/[^\d.]/g, ''));
            }
        }
        
        if (isNaN(originalPrice)) {
            return;
        }
        
        // 割引価格を計算
        const discountedPrice = calculateDiscountedPrice(
            originalPrice, 
            matchingDiscount.type, 
            matchingDiscount.value
        );
        
        // 通貨フォーマット（円表記）
        const formattedDiscountedPrice = Math.floor(discountedPrice).toLocaleString('ja-JP') + '円';
        
        // 価格表示をセール価格形式に変更
        priceElement.classList.add('f-price--on-sale');
        
        // セール価格の要素を作成または更新
        let salePriceDiv = existingSaleDiv;
        if (!salePriceDiv) {
            salePriceDiv = document.createElement('div');
            salePriceDiv.className = 'f-price__sale';
            salePriceDiv.innerHTML = `
                <span class="visually-hidden visually-hidden--inline">セール価格</span>
                <span class="f-price-item f-price-item--sale"></span>
                <span class="visually-hidden visually-hidden--inline">通常価格</span>
                <span class="f-price-item f-price-item--regular">
                    <s></s>
                </span>
            `;
            priceElement.appendChild(salePriceDiv);
        }
        
        // 価格を更新
        const salePrice = salePriceDiv.querySelector('.f-price-item--sale');
        const regularPriceInSale = salePriceDiv.querySelector('.f-price-item--regular s');
        
        if (salePrice) {
            salePrice.textContent = formattedDiscountedPrice;
        }
        
        // セール価格表示内の通常価格を更新
        if (regularPriceInSale && existingRegularDiv) {
            const regularPriceItem = existingRegularDiv.querySelector('.f-price-item--regular');
            if (regularPriceItem) {
                regularPriceInSale.textContent = regularPriceItem.textContent;
            }
        }
        
        // 通常価格の表示を非表示にする
        if (existingRegularDiv) {
            existingRegularDiv.style.display = 'none';
        }
        
        // 処理済みマークを付ける
        priceElement.setAttribute('data-discount-applied', 'true');
        
        // 商品カードのバッジエリアにセールバッジを追加
        const productCard = priceElement.closest('.product-card');
        if (productCard) {
            // 既にセール価格で表示されている商品（Shopify側でセール設定されている商品）はスキップ
            const existingSaleDiv = priceElement.querySelector('.f-price__sale');
            const isAlreadyOnSale = existingSaleDiv && priceElement.classList.contains('f-price--on-sale') && 
                                   priceElement.getAttribute('data-compare-at-price');
            
            if (isAlreadyOnSale) {
                return;
            }
            
            let badgeArea = productCard.querySelector('.product-card__badge');
            
            // バッジエリアが存在しない場合は、motion-elementの後に作成
            if (!badgeArea) {
                const motionElement = productCard.querySelector('motion-element');
                if (motionElement) {
                    badgeArea = document.createElement('div');
                    badgeArea.className = 'product-card__badge';
                    
                    // motion-elementの次に挿入
                    motionElement.parentNode.insertBefore(badgeArea, motionElement.nextSibling);
                }
            }
            
            if (badgeArea) {
                // 既存のセールバッジがあるか確認（Shopifyのセールバッジ）
                const existingSaleBadge = badgeArea.querySelector('.f-badge--sale:not(.f-badge--discount)');
                if (existingSaleBadge) {
                    return;
                }
                
                // 既存の割引バッジがあるか確認
                const existingDiscountBadge = badgeArea.querySelector('.f-badge--discount');
                if (!existingDiscountBadge) {
                    // バッジ要素を作成
                    const discountBadge = document.createElement('span');
                    discountBadge.className = 'f-badge f-badge--sale f-badge--discount';
                    discountBadge.setAttribute('aria-hidden', 'true');
                    discountBadge.textContent = 'Sale';
                    
                    // バッジエリアに追加
                    badgeArea.appendChild(discountBadge);
                }
            }
        }
    }

    // 価格表示を更新する関数
    function updatePriceDisplay() {
        // 前回の処理済みマークをクリア
        const processedElements = document.querySelectorAll('[data-discount-applied]');
        processedElements.forEach(element => {
            element.removeAttribute('data-discount-applied');
        });
        
        // 前回追加した割引バッジをクリア
        const discountBadges = document.querySelectorAll('.f-badge--discount');
        discountBadges.forEach(badge => {
            badge.remove();
        });
        
        // 複数のCookie名を試す
        let discountCode = getCookie('discount');
        let cookieName = 'discount';
        
        if (!discountCode) {
            // 他の可能性のあるCookie名も確認
            const possibleNames = ['discount_code', 'discountCode', 'code'];
            for (const name of possibleNames) {
                const value = getCookie(name);
                if (value) {
                    discountCode = value;
                    cookieName = name;
                    break;
                }
            }
        }
        
        if (!discountCode) {
            return;
        }

        // メタオブジェクトのデータを取得（Liquidで出力されたデータ）
        const discountMetaobjects = window.discountMetaobjects || [];
        
        // 該当する割引情報をすべて検索
        const matchingDiscounts = discountMetaobjects.filter(discount => 
            discount.code === discountCode
        );
        
        if (matchingDiscounts.length === 0) {
            return;
        }

        // 複数のディスカウントがある場合はすべてを処理
        matchingDiscounts.forEach((matchingDiscount) => {
            // 対象商品のIDリスト
            const targetProductIds = matchingDiscount.products || [];
        
            // 現在のページの商品IDを取得
            let currentProductId = window.currentProductId;
            
            // 商品一覧ページなど、商品ページ以外での商品IDを取得
            if (!currentProductId) {
                // 価格要素から直接商品IDを取得
                const priceElements = document.querySelectorAll('.f-price[data-product-id]');
                
                // 商品ページかどうかを確認
                const isProductPage = document.querySelector('.product__info-container') !== null;
                let productPageProductId = null;
                
                priceElements.forEach(priceElement => {
                    const productId = priceElement.getAttribute('data-product-id');
                    
                    // 文字列として比較
                    if (productId && targetProductIds.map(id => String(id)).includes(String(productId))) {
                        updateSinglePriceElement(priceElement, matchingDiscount);
                        
                        // 商品ページの場合、最初にマッチした商品IDを記録
                        if (isProductPage && !productPageProductId) {
                            productPageProductId = productId;
                        }
                    }
                });
                
                // 商品ページでマッチした商品があれば、バッジを追加
                if (isProductPage && productPageProductId) {
                    addProductPageBadge(matchingDiscount, productPageProductId);
                }
            } else {
                // 商品ページの場合、価格要素から商品IDを取得する試み
                if (!currentProductId) {
                    const priceElement = document.querySelector('.f-price[data-product-id]');
                    if (priceElement) {
                        currentProductId = priceElement.getAttribute('data-product-id');
                    }
                }
                
                // 商品ページで価格要素がある場合は、IDに関わらず処理を進める
                const priceElements = document.querySelectorAll('.f-price');
                if (priceElements.length > 0) {
                    // 各価格要素をチェック
                    let isTargetProduct = false;
                    priceElements.forEach((priceElement) => {
                        const elementProductId = priceElement.getAttribute('data-product-id');
                        if (elementProductId && targetProductIds.map(id => String(id)).includes(String(elementProductId))) {
                            isTargetProduct = true;
                        }
                    });
                    
                    // 対象商品の場合、または商品IDが確認できない商品ページの場合
                    if (isTargetProduct || (!currentProductId && priceElements.length > 0)) {
                        priceElements.forEach((priceElement) => {
                            updateSinglePriceElement(priceElement, matchingDiscount);
                        });
                        
                        // 商品ページのバッジも更新（商品IDがなくても実行）
                        const productIdForBadge = currentProductId || 'product-page';
                        addProductPageBadge(matchingDiscount, productIdForBadge);
                    }
                } else if (currentProductId && targetProductIds.map(id => String(id)).includes(String(currentProductId))) {
                    // 価格要素がなくても商品IDがマッチする場合
                    addProductPageBadge(matchingDiscount, currentProductId);
                }
            }
        }); // matchingDiscounts.forEach の終了
    }

    // ページ読み込み時に価格を更新（少し遅延を入れて確実にDOMが準備された後に実行）
    setTimeout(() => {
        updatePriceDisplay();
    }, 100);

    // DOMの変更を監視して価格要素が追加された場合にも対応
    const observer = new MutationObserver((mutations) => {
        let priceElementAdded = false;
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1 && (node.classList?.contains('f-price') || node.querySelector?.('.f-price'))) {
                    priceElementAdded = true;
                }
            });
        });
        if (priceElementAdded) {
            updatePriceDisplay();
        }
    });

    // body全体を監視
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // セクションが動的に読み込まれた場合にも対応
    document.addEventListener('shopify:section:load', () => {
        updatePriceDisplay();
    });

    // テスト用：手動でCookieを設定する関数
    window.setDiscountCookie = function(code, cookieName = 'discount_code') {
        document.cookie = `${cookieName}=${code}; path=/; max-age=86400`;
        updatePriceDisplay();
    };

    // テスト用：割引機能をテストする関数
    window.testDiscount = function(code) {
        window.setDiscountCookie(code);
    };

    // デバッグ用：現在の状況を確認する関数
    window.debugDiscount = function() {
        console.log('=== DISCOUNT DEBUG INFO ===');
        console.log('Cookies:', document.cookie);
        console.log('discountMetaobjects:', window.discountMetaobjects);
        console.log('currentProductId:', window.currentProductId);
        console.log('Price elements:', document.querySelectorAll('.f-price').length);
        
        // 各価格要素の詳細情報
        document.querySelectorAll('.f-price').forEach((element, index) => {
            console.log(`Price element ${index}:`, {
                productId: element.getAttribute('data-product-id'),
                originalPrice: element.getAttribute('data-original-price'),
                compareAtPrice: element.getAttribute('data-compare-at-price'),
                hasDiscountApplied: element.hasAttribute('data-discount-applied'),
                classList: Array.from(element.classList)
            });
        });
        
        // 商品ページのバッジ関連要素をデバッグ
        console.log('=== PRODUCT PAGE BADGE DEBUG ===');
        console.log('Product info containers:', document.querySelectorAll('.product__info-container').length);
        console.log('Existing badges blocks:', document.querySelectorAll('.product__badges').length);
        console.log('Badge elements:', document.querySelectorAll('.f-badge').length);
        
        // 各コンテナの詳細
        document.querySelectorAll('.product__info-container').forEach((container, index) => {
            console.log(`Container ${index}:`, {
                hasBadgesBlock: !!container.querySelector('.product__badges'),
                hasPriceBlock: !!container.querySelector('[data-block-type="price"]'),
                hasTitleBlock: !!container.querySelector('[data-block-type="title"]'),
                hasVendorBlock: !!container.querySelector('[data-block-type="vendor"]'),
                existingBadges: container.querySelectorAll('.f-badge').length,
                innerHTML: container.innerHTML.substring(0, 200) + '...'
            });
        });
        
        // メタオブジェクトの詳細
        if (window.discountMetaobjects) {
            console.log('=== METAOBJECTS DETAIL ===');
            window.discountMetaobjects.forEach((obj, index) => {
                console.log(`Metaobject ${index}:`, obj);
            });
        }
        
        console.log('Running updatePriceDisplay...');
        updatePriceDisplay();
    };
    
    // デバッグ用：商品ページのバッジを手動で追加する関数
    window.testProductBadge = function(discountType = '割合', discountValue = 10) {
        console.log('=== TESTING PRODUCT BADGE ===');
        const testDiscount = { type: discountType, value: discountValue };
        const productId = window.currentProductId || 'test-product';
        console.log('Test discount:', testDiscount);
        console.log('Product ID:', productId);
        addProductPageBadge(testDiscount, productId);
    };


});